import Home from "../pages/home/home";
import LoginPage from "../pages/login-page/login-page";
import AuthCallback from "../components/auth/AuthCallback";
//import AuthTestPage from "../pages/AuthTestPage";
//import AuthCodeTest from "../components/auth/AuthCodeTest";
//import AuthDebugPage from "../pages/AuthDebugPage";

const routes = [
  { path: "/login-page", element: <LoginPage />, requiresAuth: false },
  { path: "/auth/callback", element: <AuthCallback />, requiresAuth: false },
  // { path: "/auth/test", element: <AuthTestPage />, requiresAuth: false },
  // { path: "/auth/debug", element: <AuthDebugPage />, requiresAuth: false },
  // { path: "/auth/test", element: <AuthCodeTest />, requiresAuth: false },
  {
    path: "/",
    element: <Home />,
    requiresAuth: true,
  },
];

export default routes;
